import { useEffect } from 'react';

export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    if (!title) return;

    const previousTitle = document.title;
    document.title = `${title} - PetroHQ`;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

export function useDocumentMeta(meta: {
  title?: string;
  description?: string;
  keywords?: string;
}) {
  useEffect(() => {
    const updates: Array<{ element: HTMLMetaElement; originalValue: string }> =
      [];

    if (meta.title) {
      document.title = `${meta.title} - PetroHQ`;
    }

    if (meta.description) {
      let descElement = document.querySelector(
        'meta[name="description"]'
      ) as HTMLMetaElement;
      if (!descElement) {
        descElement = document.createElement('meta');
        descElement.name = 'description';
        document.head.appendChild(descElement);
        updates.push({ element: descElement, originalValue: '' });
      } else {
        updates.push({
          element: descElement,
          originalValue: descElement.content,
        });
      }
      descElement.content = meta.description;
    }

    if (meta.keywords) {
      let keywordsElement = document.querySelector(
        'meta[name="keywords"]'
      ) as HTMLMetaElement;
      if (!keywordsElement) {
        keywordsElement = document.createElement('meta');
        keywordsElement.name = 'keywords';
        document.head.appendChild(keywordsElement);
        updates.push({ element: keywordsElement, originalValue: '' });
      } else {
        updates.push({
          element: keywordsElement,
          originalValue: keywordsElement.content,
        });
      }
      keywordsElement.content = meta.keywords;
    }

    return () => {
      updates.forEach(({ element, originalValue }) => {
        if (originalValue) {
          element.content = originalValue;
        } else {
          element.remove();
        }
      });
    };
  }, [meta.title, meta.description, meta.keywords]);
}
